import * as React from 'react';
import * as ReactDOM from 'react-dom';

import './style.scss';
import {BrowserRouter} from 'react-router-dom';
import Registry from './project/global/Registry';
import UserApi from './project/modules/users/api/UserApi';
import User from './project/modules/users/domain/aggregates/user/User';
import RouterBody from './RouterBody';
import * as ReactGA from 'react-ga';
import AuthenticationTokenApi from './project/modules/users/api/AuthenticationTokenApi';
import ExerciseTemplateApi from './project/modules/lessons/api/ExerciseTemplateApi';
import SearchQueryParser from './foundation/parsers/SearchQueryParser';

Registry.getInstance().initialize();

ReactGA.initialize('UA-2571148-26'); // Unique Google Analytics tracking number

// const shared = new SharedClass(); // Keep this here until real sharing occurs to keep stable directory structure

const query = SearchQueryParser.execute(window.location.search);

AuthenticationTokenApi.getInstance().getTokenOrCurrent({source: query && query.source ? query.source : undefined}).then(() =>
	UserApi.getInstance().me().then(async (user: User) => {
		await ExerciseTemplateApi.getInstance().getAll();

		Registry.getInstance().me = user;

		const root = document.createElement('div');
		root.id = 'root';
		document.body.appendChild(root);

		ReactDOM.render(
			<BrowserRouter>
				<RouterBody reactGA={ReactGA}/>
			</BrowserRouter>
			, root
		);
	})
);


// WEBPACK FOOTER //
// ./code/index.tsx